import {Injectable} from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";
import {PriceComponentDto, PriceComponentPayload} from "../dto/price.payload.dto";

/**
 * HTTP de precios por componente (W_PRICE). El precio principal de la oferta sigue en el AD
 * (ad.service); aquí van el desglose Venta (construcción/garage/baulera/jardín/total).
 */
@Injectable({
    providedIn: 'root'
})
export class PriceService {

    private urlPrefix = '/api/prices';

    constructor(private backend: BackendService) {}

    /** Registra (reemplazando los previos del mismo tipo) el desglose de precios de la propiedad. */
    registerPropertyPrices(propertyId: number, prices: PriceComponentPayload[]): Observable<any> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.post(url, prices).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    /** Obtiene el desglose de precios guardado (para resume/edición). */
    getPricesByProperty(propertyId: number): Observable<PriceComponentDto[]> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response as unknown as PriceComponentDto[])
        );
    }
}
